import { useState, type FormEvent } from 'react'
import { Button, Field } from '../../design'
import { META_APP_COPY } from './copy'

type MetaAppFormValue = { appId: string; appSecret: string }

type MetaAppFormProps = {
  initialAppId: string
  pending: boolean
  error: string | null
  onSubmit: (value: MetaAppFormValue) => void
  onCancel?: () => void
}

export const MetaAppForm = ({ initialAppId, pending, error, onSubmit, onCancel }: MetaAppFormProps) => {
  const [appId, setAppId] = useState(initialAppId)
  const [appSecret, setAppSecret] = useState('')
  const lockAppId = initialAppId !== ''

  const onFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    onSubmit({ appId, appSecret })
  }

  return (
    <form className="meta-app-form" onSubmit={onFormSubmit} noValidate>
      <Field id="meta-app-id" label={META_APP_COPY.appId}>
        {({ id }) => (
          <input
            id={id}
            inputMode="numeric"
            autoComplete="off"
            readOnly={lockAppId}
            value={appId}
            onChange={(event) => setAppId(event.target.value)}
          />
        )}
      </Field>
      <Field id="meta-app-secret" label={META_APP_COPY.appSecret} hint={META_APP_COPY.appSecretHint}>
        {({ id, describedBy }) => (
          <input
            id={id}
            type="password"
            autoComplete="off"
            aria-describedby={describedBy}
            value={appSecret}
            onChange={(event) => setAppSecret(event.target.value)}
          />
        )}
      </Field>
      {error === null ? null : (
        <p className="settings-error text-tone tone-danger" role="alert">
          {error}
        </p>
      )}
      <div className="settings-save">
        <Button type="submit" variant="primary" pending={pending} pendingLabel={META_APP_COPY.saving}>
          {META_APP_COPY.save}
        </Button>
        {onCancel === undefined ? null : <Button onClick={onCancel}>{META_APP_COPY.cancel}</Button>}
      </div>
    </form>
  )
}
